import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash.get';
import Modal from '../Modal';
import ConnectWithCollegeForm from './ConnectWithCollegeForm';
import styles from './ConnectWithCollegeModal.css';
import { toggleConnectModalAction } from '../../redux/colleges';
import IconButton from '../IconButton';
import Close from '../Icons/Close';

const ConnectWithCollegeModal = ({
    open,
    alreadyConnected,
    college,
    primaryColor,
    toggleConnectModal,
    collegeMultiApply,
    collegeName,
    collegeLocation,
}) => (<Modal
    open={open}
    className={styles.modal}
    onClose={() => toggleConnectModal(null)}
>
    <h2>{alreadyConnected ? 'Your Connection' : 'Connect'} with {collegeName} {!collegeMultiApply ? `${collegeLocation}` : ''}</h2>
    <p>Select the program{collegeMultiApply ? 's' : ''} that you are interested in below.</p>
    <ConnectWithCollegeForm
        college={college}
    />
    <IconButton
        className={styles.close}
        onClick={() => toggleConnectModal(null)}
        icon={Close}
        iconProps={{
            fill: primaryColor,
        }}
    />
</Modal>);


ConnectWithCollegeModal.propTypes = {
    open: PropTypes.bool,
    alreadyConnected: PropTypes.bool,
    collegeMultiApply: PropTypes.bool,
    collegeName: PropTypes.string,
    collegeLocation: PropTypes.string,
    toggleConnectModal: PropTypes.func,
    primaryColor: PropTypes.string,
    college: PropTypes.object,
};

export default connect(({ colleges, theme }) => {
    const college = colleges.list.find(c => (
        c.collegeID_PK === colleges.modal
    ));
    const collegeId = get(college, 'collegeID_PK', null);
    const connections = get(colleges.connections, collegeId, []);
    const alreadyConnected = connections && connections.length > 0;
    const locations = get(college, 'locations', []);
    const formatLocationName = (location) => {
        const name = get(location, 'name', 'N/A');
        const state = get(location, 'state');
        if (!state) {
            return name;
        }
        return `${name}, ${state}`;
    };
    let collegeLocation = '';
    if (locations.length === 1) {
        collegeLocation = `in ${formatLocationName(locations[0])}`;
    }
    return {
        open: !!college,
        college,
        primaryColor: theme.primaryColor,
        alreadyConnected,
        collegeMultiApply: theme.collegeMultiApply,
        collegeName: get(college, 'name', ''),
        collegeLocation,
    };
}, {
    toggleConnectModal: toggleConnectModalAction,
})(ConnectWithCollegeModal);



// WEBPACK FOOTER //
// ./src/client/Components/ConnectWithCollegeModal/ConnectWithCollegeModal.js